import React, { createContext, useContext, useState, useCallback } from 'react';
import { useFetch } from '../utils/hooks';
import { getAreas, getPorts, getContainers, getShippingLines, getCurrencies } from '../services/shipments';

const FormDataContext = createContext();

export const FormDataProvider = ({ children }) => {
  const [areasData, setAreasData] = useState(null);
  const [portsData, setPortsData] = useState(null);
  const [containersData, setContainersData] = useState(null);
  const [shippingLinesData, setShippingLinesData] = useState(null);
  const [currenciesData, setCurrenciesData] = useState(null);

  // Fetch areas
  const { data: areas, loading: areasLoading } = useFetch(useCallback(async () => {
    if (areasData) return { data: areasData };
    const response = await getAreas();
    setAreasData(response.data);
    return response;
  }, [areasData]));

  // Fetch ports
  const { data: ports, loading: portsLoading } = useFetch(useCallback(async () => {
    if (portsData) return { data: portsData };
    const response = await getPorts();
    setPortsData(response.data);
    return response;
  }, [portsData]));

  // Fetch containers
  const { data: containers, loading: containersLoading } = useFetch(useCallback(async () => {
    if (containersData) return { data: containersData };
    const response = await getContainers();
    setContainersData(response.data);
    return response;
  }, [containersData]));

  // Fetch shipping lines
  const { data: shippingLines, loading: shippingLinesLoading } = useFetch(useCallback(async () => {
    if (shippingLinesData) return { data: shippingLinesData };
    const response = await getShippingLines({ active: true });
    setShippingLinesData(response.data);
    return response;
  }, [shippingLinesData]));

  // Fetch currencies
  const { data: currencies, loading: currenciesLoading } = useFetch(useCallback(async () => {
    if (currenciesData) return { data: currenciesData };
    const response = await getCurrencies();
    setCurrenciesData(response.data);
    return response;
  }, [currenciesData]));

  const isLoading = areasLoading || portsLoading || containersLoading || shippingLinesLoading || currenciesLoading;

  const value = {
    areas,
    ports,
    containers,
    shippingLines,
    currencies,
    isLoading,
  };

  return (
    <FormDataContext.Provider value={value}>
      {children}
    </FormDataContext.Provider>
  );
};

export const useFormData = () => {
  const context = useContext(FormDataContext);
  if (!context) {
    throw new Error('useFormData must be used within a FormDataProvider');
  }
  return context;
};
